/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

// tslint:disable-next-line: interface-name
export interface Open360BusinessLogicPlacesPlacesPlaceWithStateListModel {
    ID?: number;
    Name?: string;
    Town?: string;
    Address?: string;
    /**
     * 1 = Shop, 2 = ShoppingCentre, 3 = Restaurant, 4 = Attraction, 5 = Accommodation, 6 = Education, 7 = Exhibition, 8 = Exhibitor
     */
    BusinessType?: Open360BusinessLogicPlacesPlacesPlaceWithStateListModel.BusinessTypeEnum;
    CoverID?: number;
    LogoID?: number;
    IsWebsiteUrlExist?: boolean;
    IsDescriptionExist?: boolean;
    IsOpeningHoursExist?: boolean;
    IsInventoryTypeExist?: boolean;
    CampaignsCount?: number;
    FollowersCount?: number;
}
// tslint:disable-next-line: no-namespace
export namespace Open360BusinessLogicPlacesPlacesPlaceWithStateListModel {
    export type BusinessTypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
    export const BusinessTypeEnum = {
        NUMBER_1: 1 as BusinessTypeEnum,
        NUMBER_2: 2 as BusinessTypeEnum,
        NUMBER_3: 3 as BusinessTypeEnum,
        NUMBER_4: 4 as BusinessTypeEnum,
        NUMBER_5: 5 as BusinessTypeEnum,
        NUMBER_6: 6 as BusinessTypeEnum,
        NUMBER_7: 7 as BusinessTypeEnum,
        NUMBER_8: 8 as BusinessTypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicPlacesPlacesPlaceWithStateListModel.ts